const PersonUp = ({ className, width, height, x, y }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 100 125"
      //enable-background="new 0 0 100 100"
      className={className}
      width={width}
      height={height}
      x={x}
      y={y}
    >
      <g>
        <path d="M50.64,26.5c4.571,0,7.89-3.575,7.89-8.5s-3.318-8.5-7.89-8.5c-4.572,0-7.89,3.575-7.89,8.5   S46.068,26.5,50.64,26.5z" />
        <path d="M74.533,11.5c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,12.262-7.19,20.5-17.893,20.5   c-10.703,0-17.893-8.238-17.893-20.5c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,11.487,5.33,20.417,13.752,24.332V89c0,1.657,1.343,3,3,3   s3-1.343,3-3V62c0-2.067,1.682-3.75,3.75-3.75c2.067,0,3.75,1.683,3.75,3.75v27c0,1.657,1.343,3,3,3s3-1.343,3-3V36.179   C68.874,32.462,74.533,23.338,74.533,11.5z" />
      </g>
    </svg>
  )
}

export default PersonUp
